module.exports = __webpack_public_path__ + "static/media/train.2d8438d7.svg";